import { authFetch } from '~/services/fetch'

export async function getAverageDispatchTotalTime({
  agencyId,
  deviceId,
  operationId,
  dispatchGroupId,
  categoryIds,
  typeIds,
  subtypeIds,
  startDate,
  finishDate,
  payload,
  consummated,
  statusIds,
  cityIds,
  groupSetId,
  location,
  closedStatusClassId,
  closedStatusId,
  qualifierOptions,
  operationUnitId,
  phone,
  name,
  userId,
  geographicAreas,
  districtIds,
  startTime,
  endTime,
}) {
  try {
    const { data } = await authFetch({
      method: 'POST',
      url: '/statistics/average-dispatch-total-time',
      // url: '/statistics/average-dispatch-closing-time',
      data: {
        agencyId: agencyId,
        deviceId: deviceId,
        operationId: operationId,
        dispatchGroupIds: dispatchGroupId,
        categoryIds: categoryIds,
        typeIds: typeIds,
        subtypeIds: subtypeIds,
        startDate: startDate,
        finishDate: finishDate,
        excludeClosed: payload.exludeClosed,
        withSolvedThirdParty: payload.withSolvedThirdParty,
        consummated: consummated,
        statusIds: statusIds,
        cityIds: cityIds,
        districtIds: districtIds,
        groupSetId: groupSetId,
        location: location,
        closedStatusClassId: closedStatusClassId,
        closedStatusId: closedStatusId,
        qualifierOptions: qualifierOptions,
        operationUnitId: operationUnitId,
        phone: phone,
        geographicAreas: geographicAreas,
        name: name,
        userId: userId,
        startTime: startTime,
        endTime: endTime,
      },
    })
    return data.average_total_time
  } catch (error) {
    throw error
  }
}

export async function getAverageDispatchTime({
  agencyId,
  deviceId,
  operationId,
  dispatchGroupId,
  categoryIds,
  typeIds,
  subtypeIds,
  startDate,
  finishDate,
  payload,
  consummated,
  statusIds,
  cityIds,
  groupSetId,
  location,
  closedStatusClassId,
  closedStatusId,
  qualifierOptions,
  operationUnitId,
  phone,
  name,
  userId,
  geographicAreas,
  districtIds,
  startTime,
  endTime,
}) {
  try {
    const { data } = await authFetch({
      method: 'POST',
      url: '/statistics/average-dispatch-time',
      // url: '/statistics/average-dispatch-closing-time',
      data: {
        agencyId: agencyId,
        deviceId: deviceId,
        operationId: operationId,
        dispatchGroupIds: dispatchGroupId,
        categoryIds: categoryIds,
        typeIds: typeIds,
        subtypeIds: subtypeIds,
        startDate: startDate,
        finishDate: finishDate,
        excludeClosed: payload.exludeClosed,
        withSolvedThirdParty: payload.withSolvedThirdParty,
        consummated: consummated,
        statusIds: statusIds,
        cityIds: cityIds,
        districtIds: districtIds,
        groupSetId: groupSetId,
        location: location,
        closedStatusClassId: closedStatusClassId,
        closedStatusId: closedStatusId,
        qualifierOptions: qualifierOptions,
        operationUnitId: operationUnitId,
        phone: phone,
        geographicAreas: geographicAreas,
        name: name,
        userId: userId,
        startTime: startTime,
        endTime: endTime,
      },
    })
    return data.average_dispatch_time
  } catch (error) {
    throw error
  }
}

export async function getAverageDisplacementTime({
  agencyId,
  deviceId,
  operationId,
  dispatchGroupId,
  categoryIds,
  typeIds,
  subtypeIds,
  startDate,
  finishDate,
  payload,
  consummated,
  statusIds,
  cityIds,
  groupSetId,
  location,
  closedStatusClassId,
  closedStatusId,
  qualifierOptions,
  operationUnitId,
  phone,
  name,
  userId,
  geographicAreas,
  districtIds,
  startTime,
  endTime,
}) {
  try {
    const { data } = await authFetch({
      method: 'POST',
      url: '/statistics/average-displacement-time',
      // url: '/statistics/average-dispatch-closing-time',
      data: {
        agencyId: agencyId,
        deviceId: deviceId,
        operationId: operationId,
        dispatchGroupIds: dispatchGroupId,
        categoryIds: categoryIds,
        typeIds: typeIds,
        subtypeIds: subtypeIds,
        startDate: startDate,
        finishDate: finishDate,
        excludeClosed: payload.exludeClosed,
        withSolvedThirdParty: payload.withSolvedThirdParty,
        consummated: consummated,
        statusIds: statusIds,
        cityIds: cityIds,
        districtIds: districtIds,
        groupSetId: groupSetId,
        location: location,
        closedStatusClassId: closedStatusClassId,
        closedStatusId: closedStatusId,
        qualifierOptions: qualifierOptions,
        operationUnitId: operationUnitId,
        phone: phone,
        geographicAreas: geographicAreas,
        name: name,
        userId: userId,
        startTime: startTime,
        endTime: endTime,
      },
    })
    return data.average_displacement_time
  } catch (error) {
    throw error
  }
}

export async function getAverageDispatchFinishTime({
  agencyId,
  deviceId,
  operationId,
  dispatchGroupId,
  categoryIds,
  typeIds,
  subtypeIds,
  startDate,
  finishDate,
  payload,
  consummated,
  statusIds,
  cityIds,
  groupSetId,
  location,
  closedStatusClassId,
  closedStatusId,
  qualifierOptions,
  operationUnitId,
  phone,
  name,
  userId,
  geographicAreas,
  districtIds,
  startTime,
  endTime,
}) {
  try {
    const { data } = await authFetch({
      method: 'POST',
      url: '/statistics/average-dispatch-finish-time',
      // url: '/statistics/average-dispatch-closing-time',
      data: {
        agencyId: agencyId,
        deviceId: deviceId,
        operationId: operationId,
        dispatchGroupIds: dispatchGroupId,
        categoryIds: categoryIds,
        typeIds: typeIds,
        subtypeIds: subtypeIds,
        startDate: startDate,
        finishDate: finishDate,
        excludeClosed: payload.exludeClosed,
        withSolvedThirdParty: payload.withSolvedThirdParty,
        consummated: consummated,
        statusIds: statusIds,
        cityIds: cityIds,
        districtIds: districtIds,
        groupSetId: groupSetId,
        location: location,
        closedStatusClassId: closedStatusClassId,
        closedStatusId: closedStatusId,
        qualifierOptions: qualifierOptions,
        operationUnitId: operationUnitId,
        phone: phone,
        geographicAreas: geographicAreas,
        name: name,
        userId: userId,
        startTime: startTime,
        endTime: endTime,
      },
    })
    return data.average_finishing_time
  } catch (error) {
    throw error
  }
}
